module.exports = __webpack_public_path__ + "img/Alert.aed673ca.svg";